import api from "./axios";
import type { AuthTokens, User } from "../types";

export interface TokenVerifyResult {
  valid: boolean;
  email?: string;
  firstName?: string;
  error?: string;
}

export const authApi = {
  login: async (email: string, password: string): Promise<AuthTokens> => {
    const res = await api.post<AuthTokens>("/auth/login", { email, password });
    return res.data;
  },

  me: async (): Promise<User> => {
    const res = await api.get<User>("/auth/me");
    return res.data;
  },

  changePassword: async (
    currentPassword: string,
    newPassword: string
  ): Promise<void> => {
    await api.put("/auth/password", { currentPassword, newPassword });
  },

  forgotPassword: async (email: string): Promise<void> => {
    await api.post("/auth/forgot-password", { email });
  },

  verifyToken: async (
    token: string,
    type: "reset" | "invite"
  ): Promise<TokenVerifyResult> => {
    const res = await api.get<TokenVerifyResult>("/auth/verify-token", {
      params: { token, type },
    });
    return res.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<void> => {
    await api.post("/auth/reset-password", { token, newPassword });
  },

  acceptInvite: async (
    token: string,
    newPassword: string
  ): Promise<AuthTokens> => {
    const res = await api.post<AuthTokens>("/auth/accept-invite", { token, newPassword });
    return res.data;
  },
};
